export default __webpack_public_path__ + "static/media/rocas.abce2112.png";